import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { markFilter, typeFilter } from './filters';

interface Modification extends ListRow {
  id: number;
  name?: string;
  model_name?: string;
  mark_name?: string;
  modification_name?: string;
}

const config: ListPageConfig<Modification> = {
  queryKey: 'car-modifications',
  title: 'Справочник авто',
  boxTitle: 'Модификация',
  errorText: 'Ошибка загрузки модификаций',
  fetchList: postListFetcher('/car/modification/list/'),
  rows: ['list'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'name', label: 'Поиск по модели' },
  ],
  filters: [typeFilter, markFilter],
  columns: [
    { header: 'id', sortField: 'id', render: (item) => item.id },
    { header: 'Модель', sortField: 'name', render: (item) => item.model_name || 'No models' },
    { header: 'Марка', sortField: 'mark_id', render: (item) => item.mark_name || 'No mark' },
    { header: 'Поколение', sortField: 'generation_id', render: (item) => item.name || 'No generation' },
    {
      header: 'Модификация',
      sortField: 'modification_id',
      render: (item) => item.modification_name || 'No modifications',
    },
  ],
};

export const ModificationsPage = () => <GenericListPage config={config} />;
